import ICustomerService from "features/customer/services/ICustomerService";
import { updateCsLocale } from "features/shared/components/reactDates/reactDatesHelper";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import CustomerState from "infrastructure/store/customer/CustomerState";
import IAppState from "infrastructure/store/IAppState";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// moment locales
import moment from "moment";
import "moment/locale/sk";
import "moment/locale/cs";

export const useAppLocalization = () => {
  // DI
  const customerService = useInjection<ICustomerService>(IocTypes.CustomerService);

  // translations
  const { i18n } = useTranslation();

  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;

  // side-effects
  useEffect(() => {
    // setting localizaction for moment (react-dates components)
    updateCsLocale();
    moment.locale(i18n.language);

    // refresh store data based on language
    if (customer.customerId) {
      customerService.loadAndStoreAlerts(customer.customerId);
      customerService.loadAndStoreRequirementTypes(customer.customerId);
    }
  }, [i18n.language]);
}